import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBook = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.044 16.025h12.393l.007 3.78a1.2 1.2 0 0 1-1.199 1.194H7.044a2.486 2.486 0 1 1 0-4.974"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.557 18.513V5.591A2.59 2.59 0 0 1 7.147 3H18.24a1.2 1.2 0 0 1 1.198 1.199v11.827M11.98 7.13h1.473m-1.473 2.892h3.329M8.36 3.014v12.994"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBook);
export default ForwardRef;
